// extracted by mini-css-extract-plugin
module.exports = {"unauthorised":"Unauthorised_unauthorised__3XKNi","container":"Unauthorised_container__3ApmJ","subHeading":"Unauthorised_subHeading__13ONW"};